import * as constants from '../constants'
import { BondListState } from '../types'
import {
  ClearSelectBond,
  CloseBondDetails,
  FulfillBonds,
  GetBondConfig,
  SelectBond,
  ViewBondDetails,
} from '../actions/bondActions'

export const initialBondListState: BondListState = {
  selectedBond: undefined,
  viewBondDetails: false,
}

type Action =
  | FulfillBonds
  | SelectBond
  | ClearSelectBond
  | ViewBondDetails
  | CloseBondDetails
  | GetBondConfig

export function bondsReducers(
  state: BondListState = initialBondListState,
  action: Action
): BondListState {
  switch (action.type) {
    case constants.SELECT_BOND:
      return { ...state, selectedBond: action.bond }
    case constants.CLEAR_SELECT_BOND:
      return { ...state, selectedBond: undefined, viewBondDetails: false }
    case constants.VIEW_BOND_DETAILS:
      return { ...state, selectedBond: action.bond, viewBondDetails: true }
    case constants.CLOSE_BOND_DETAILS:
      return { ...state, viewBondDetails: false }
    default:
      return { ...state }
  }
}
